// Matches Bookings.jsx's known-good currency-sourcing chain: the vendor's
// currency lives on localStorage["vendorProfile"].currency (written by
// Navbar.jsx from the ezpMyProfile API response) - NOT localStorage
// ["userDetails"], which lacks a currency field entirely and silently
// resolves to undefined. Falls back to the flat localStorage["currency"]
// key (also written by Navbar.jsx), then "AED".
export function getVendorCurrency() {
  try {
    const vendorProfile = JSON.parse(localStorage.getItem("vendorProfile")) || {};
    return vendorProfile.currency || localStorage.getItem("currency") || "AED";
  } catch {
    return localStorage.getItem("currency") || "AED";
  }
}
